import { DescriptionItem } from '@core/ui';
import { ReactNode } from 'react';

/** One labelled detail (date, time, duration, …) on a webinar's detail page; render inside a <dl>. */
export const WebinarInfoItem = ({ children, icon, label }: { children: ReactNode; icon: ReactNode; label: string }) => {
    return (
        <DescriptionItem classNames="flex flex-col" termClassNames="flex items-center" detailsClassNames="font-light md:text-xl" icon={icon} label={label}>
            {children}
        </DescriptionItem>
    );
};
